import AirplaneIcon from '../../../../../assets/images/activity/airplane.png';
import CalendarIcon from '../../../../../assets/images/activity/calendar.png';

export const SECTION_TYPES = {
  Today: {
    icon: CalendarIcon,
    label: selectedDate => {
      if (!selectedDate) return 'Today';
      const today = new Date();
      const isSameDay =
        selectedDate.getFullYear() === today.getFullYear() &&
        selectedDate.getMonth() === today.getMonth() &&
        selectedDate.getDate() === today.getDate();
      return isSameDay
        ? 'Today'
        : `${selectedDate.getDate()} ${selectedDate.toLocaleString('default', { month: 'long' })} ${selectedDate.getFullYear()}`;
    },
  },
  Vacation: {
    icon: AirplaneIcon,
    label: () => 'Vacation',
  },
  Others: {
    label: () => 'Others',
  },
};
